import { connect } from 'react-redux';
import { contractsSelector } from '../../modules/LegalDocuments/Contracts/selectors';
import Contracts from './Contracts';

const mapStateToProps = state => ({
  contracts: contractsSelector(state),
});

export default connect(mapStateToProps)(Contracts);
